/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import {
  Box, Divider, Grid, Typography,
} from '@mui/material';

function InputContainer({ title, children, buttonsForDynamicInputs }) {
  return (
    <Box>
      <Divider orientation="horizontal" variant="fullWidth" />
      <Typography pt={1.5} pb={1.5} fontSize={22}>{title}</Typography>
      {buttonsForDynamicInputs ? (
        <>{children}</>
      ) : (
        <Grid container spacing={2}>
          {children}
        </Grid>
      )}
    </Box>
  );
}

export default InputContainer;
